import { Component, Input, NgZone, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { PageRequestDTO, PageResponseDTO } from '../../../../../common/paging-dto';
import {
  AggFieldConfigDO,
  AggFieldType,
  FieldConfigDTO,
  MaintainTabDTO,
  MenuDTO,
  MenuType,
} from '../../../../../system/system-dtos';
import { QueryDataSource } from '../../data-source/query-data-source';
import { DataTypeAggsService } from '../../../../data-type-widgets/data-type/services/data-type-aggs.service';
import { MenuUtils } from '../../../../../common/utils/menu-utils';

@Component({
  selector: 'app-results-information',
  templateUrl: './results-information.component.html',
  styleUrls: ['./results-information.component.css'],
  standalone: false,
})
export class ResultsInformationComponent implements OnChanges {
  @Input() pageResponse: PageResponseDTO<any>;

  @Input() tab: MaintainTabDTO;

  @Input() menuConfig: MenuDTO;

  @Input() filters: { [p: string]: FieldConfigDTO };

  @Input() realTimeInput: string;

  @Input() id: any;

  @Input() context: any;

  @Input() tableData: MatTableDataSource<any>;

  lastTimerId: number;

  aggs: Map<string, string>;

  constructor(
    private http: HttpClient,
    private dataTypeAggsService: DataTypeAggsService,
    private zone: NgZone,
    private queryDataSource: QueryDataSource
  ) {}

  private updateAgssMap() {
    const kibanaQueryDTO = this.queryDataSource.buildKibanaQuery(
      this.menuConfig,
      {},
      this.filters,
      this.id,
      this.context,
      {},
      null
    );

    this.http
      .post(this.tab.tableView.aggsUrl, kibanaQueryDTO)
      .subscribe((d) => (this.aggs = new Map(Object.entries(d as any))));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.realTimeInput && !changes.realTimeInput.isFirstChange()) {
      this.updateAggsForTickers();
    } else if (changes.pageResponse && this.tab && this.tab.tableView.aggsUrl) {
      this.updateAgssMap();
    } else if (
      changes.pageResponse &&
      this.menuConfig.entityGroup &&
      this.menuConfig.entityGroup.dataSources[this.menuConfig.entityGroup.currentMode].type === MenuType.TICKER &&
      this.pageResponse &&
      this.pageResponse.content &&
      this.pageResponse.content.length > 0
    ) {
      this.updateAggsForTickers();
    } else {
      this.aggs = null;
    }
  }

  private updateAggsForTickers() {
    const aggDefMap = new Map<AggFieldType, any>();
    MenuUtils.getFirstTickerConfig(this.menuConfig.entityGroup)
      ?.rows[0]?.columns[0]?.fields.filter((f) => f.aggs)
      .forEach((f) => {
        f.aggs.forEach((agg: AggFieldConfigDO) => {
          aggDefMap.set(agg.type, f);
        });
      });

    const aggMap = new Map<string, string>();
    aggDefMap.forEach((def: FieldConfigDTO, type) => {
      const data = this.tableData.filteredData.map((d) => d.data);
      aggMap.set(`${type} ${def.label}`, this.dataTypeAggsService.aggregate(type, def, data));
    });

    this.aggs = aggMap;
  }
}
